import { Entry } from 'contentful'
import { CONTENT_TYPE } from 'marketing-site/@types/generated/contentful'
import dynamic from 'next/dynamic'
import { ReactComponentLike } from 'prop-types'
import React from 'react'

const ContentfulBadges = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulBadges')).ContentfulBadges,
)

const ContentfulCrosslinkCards = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulCrosslinkCards'))
      .ContentfulCrosslinkCards,
)

const ContentfulEmailCapture = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulEmailCapture'))
      .ContentfulEmailCapture,
)

const ContentfulLogoParty = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulLogoParty'))
      .ContentfulLogoParty,
)

const ContentfulHeroEmailCapture = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulHeroEmailCapture'))
      .ContentfulHeroEmailCapture,
)

const ContentfulHero = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulHero')).ContentfulHero,
)

const ContentfulHeroHorizontal = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulHeroHorizontal'))
      .ContentfulHeroHorizontal,
)

const ContentfulHeroVertical = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulHeroVertical'))
      .ContentfulHeroVertical,
)

const ContentfulNewFeatureAnnouncement = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulNewFeatureAnnouncement'))
      .ContentfulNewFeatureAnnouncement,
)

const ContentfulRooflineBanner = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulRooflineBanner'))
      .ContentfulRooflineBanner,
)
const ContentfulRooflineBannerMvp = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulRooflineBanner'))
      .ContentfulRooflineBanner,
)
const ContentfulGatedContent = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulGatedContent'))
      .ContentfulGatedContent,
)
const ContentfulGatedContentMvp = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulGatedContent'))
      .ContentfulGatedContent,
)

const ContentfulFeatureSpotlight = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulFeatureSpotlight'))
      .ContentfulFeatureSpotlight,
)

const ContentfulFeatureSpotlightMVP = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulFeatureSpotlight'))
      .ContentfulFeatureSpotlight,
)

const ContentfulFeatureSpotlightWithTestimonialMVP = dynamic(
  async () =>
    (
      await import(
        'marketing-site/src/mvp/transformers/components/ContentfulFeatureSpotlightWithTestimonial'
      )
    ).ContentfulFeatureSpotlightTestimonial,
)

const ContentfulMultiFeatureSpotlightMVP = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulMultiFeatureSpotlight'))
      .ContentfulMultiFeatureSpotlight,
)

const ContentfulFeatureSpotlightVertical = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulFeatureSpotlightVertical'))
      .ContentfulFeatureSpotlightVertical,
)

const ContentfulFeatureSpotlightVerticalMvp = dynamic(
  async () =>
    (
      await import(
        'marketing-site/src/mvp/transformers/components/ContentfulFeatureSpotlightVertical'
      )
    ).ContentfulFeatureSpotlightVertical,
)

const ContentfulSpotlightDrawers = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulSpotlightDrawers'))
      .ContentfulSpotlightDrawers,
)

const ContentfulSpotlightCarousel = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulSpotlightCarousel'))
      .ContentfulSpotlightCarousel,
)

const ContentfulContentDownloadInterstitial = dynamic(
  async () =>
    (
      await import(
        'marketing-site/src/mvp/transformers/components/ContentfulContentDownloadInterstitial'
      )
    ).ContentfulContentDownloadInterstitial,
)

const ContentfulMiniTestimonials = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulMiniTestimonials'))
      .ContentfulMiniTestimonials,
)

const ContentfulMiniTestimonialCardsMVP = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulMiniTestimonialCards'))
      .ContentfulMiniTestimonialCards,
)

const ContentfulFeatureSpotlightTestimonial = dynamic(
  async () =>
    (
      await import(
        'marketing-site/src/transformers/components/ContentfulFeatureSpotlightTestimonial'
      )
    ).ContentfulFeatureSpotlightTestimonial,
)

const ContentfulMultiFeatureSpotlight = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulMultiFeatureSpotlight'))
      .ContentfulMultiFeatureSpotlight,
)

const ContentfulWhatsIncluded = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulWhatsIncluded'))
      .ContentfulWhatsIncluded,
)

const ContentfulHeadingBlock = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulHeadingBlock'))
      .ContentfulHeadingBlock,
)

const ContentfulGlossary = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulGlossary'))
      .ContentfulGlossary,
)

const ContentfulHeadingBlockMvp = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulHeadingBlock'))
      .ContentfulHeadingBlock,
)

const ContentfulHeaderNavigation = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulHeaderNavigation'))
      .ContentfulHeaderNavigation,
)

const ContentfulHeaderNavigationMVP = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulHeaderNavigation'))
      .ContentfulHeaderNavigation,
)

const ContentfulLargeTestimonial = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulLargeTestimonial'))
      .ContentfulLargeTestimonial,
)

const ContentfulFooter = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulFooter')).ContentfulFooter,
)

const ContentfulFooterMVP = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulFooter'))
      .ContentfulFooter,
)

const ContentfulFeatureSpotlightDemo = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulFeatureSpotlightDemo'))
      .ContentfulFeatureSpotlightDemo,
)

const ContentfulHeroWithCta = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulHeroWithCTA'))
      .ContentfulHeroWithCta,
)

const ContentfulHeroForEarlyStage = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulHeroForEarlyStage'))
      .ContentfulHeroForEarlyStage,
)

const ContentfulTestimonialTextOnly = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulTestimonialTextOnly'))
      .ContentfulTestimonialTextOnly,
)

const ContentfulFeatureSpotlightVideo = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulFeatureSpotlightVideo'))
      .ContentfulFeatureSpotlightVideo,
)

const ContentfulVideoPlayer = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulVideoPlayer'))
      .ContentfulVideoPlayer,
)

const ContentfulCardsWithImage = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulCardsWithImage'))
      .ContentfulCardsWithImage,
)

const ContentfulInteractiveCard = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/elements/ContentfulInteractiveCard'))
      .ContentfulInteractiveCard,
)

const ContentfulResourceHub = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulResourceHub'))
      .ContentfulResourceHub,
)

const ContentfulRichText = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulRichText'))
      .ContentfulRichText,
)

const ContentfulFeatureGrid = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulFeatureGrid'))
      .ContentfulFeatureGrid,
)

const ContentfulFeatureGridMVP = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulFeatureGrid'))
      .ContentfulFeatureGrid,
)

const ContentfulFeatureListSimple = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulFeatureListSimple'))
      .ContentfulFeatureList,
)

const ContentfulStatistic = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulStatistic'))
      .ContentfulStatistic,
)

const ContentfulStatisticMVP = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/elements/ContentfulStatistic'))
      .ContentfulStatistic,
)

const ContentfulStatistics = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulStatistics'))
      .ContentfulStatistics,
)

const ContentfulStatisticsMVP = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulStatistics'))
      .ContentfulStatistics,
)

const ContentfulHeroWithVideo = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulHeroWithVideo'))
      .ContentfulHeroWithVideo,
)

const ContentfulEditorialStoryGrid = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulEditorialStoryGrid'))
      .ContentfulCustomerStoryGrid,
)

const ContentfulMarketoForm = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulMarketoForm'))
      .ContentfulMarketoForm,
)

const ContentfulHeroForCareersPage = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulHeroForCareersPage'))
      .ContentfulHeroForCareersPage,
)

const ContentfulLayout = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulLayout')).ContentfulLayout,
)

const ContentfulProductList = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulProductList'))
      .ContentfulProductList,
)

const ContentfulSolutionWithTiers = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulSolutionWithTiers'))
      .ContentfulSolutionWithTiers,
)

const ContentfulTabbedSolutions = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulTabbedSolutions'))
      .ContentfulTabbedSolutions,
)

const ContentfulPricingAddOns = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulPricingAddOns'))
      .ContentfulPricingAddOns,
)

const ContentfulPricingAddOnCard = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulPricingAddOnCard'))
      .ContentfulPricingAddOnCard,
)

const ContentfulTierPricingSection = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulTierPricingSection'))
      .ContentfulTierPricingSection,
)

const ContentfulSolutionFeature = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulSolutionFeature'))
      .ContentfulSolutionFeature,
)

const ContentfulFeatureSection = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulFeatureSection'))
      .ContentfulFeatureSection,
)

const ContentfulProductToursDemo = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulProductToursDemo'))
      .ContentfulProductToursDemo,
)

const ContentfulCallout = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulCallout'))
      .ContentfulCallout,
)

const ContentfulBasicHeader = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulBasicHeader'))
      .ContentfulBasicHeader,
)

const ContentfulCardWithIcon = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulCardWithIcon'))
      .ContentfulCardWithIcon,
)

const ContentfulCardWithImage = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulCardWithImage'))
      .ContentfulCardWithImage,
)

const ContentfulCardsWithIcon = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulCardsWithIcon'))
      .ContentfulCardsWithIcon,
)

const ContentfulVariationContainer = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulVariationContainer'))
      .ContentfulVariationContainer,
)

const ContentfulGreenhouseListings = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulGreenhouseListings'))
      .ContentfulGreenhouseListings,
)

const ContentfulPlanColumnGroup = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulPlanColumnGroup'))
      .ContentfulPlanColumnGroup,
)

const ContentfulPlatform = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulPlatform'))
      .ContentfulPlatform,
)

const ContentfulPlanColumnGroupLayout = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulPlanColumnGroupLayout'))
      .ContentfulPlanColumnGroupLayout,
)

const ContentfulPricingTierCard = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulPricingTierCard'))
      .ContentfulPricingTierCard,
)

const ContentfulAddonPricingModal = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulAddonPricingModal'))
      .ContentfulAddOnPricingModal,
)

const ContentfulMobileAppsHero = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulMobileAppsHero'))
      .ContentfulMobileAppsHero,
)

const ContentfulEditorialWrap = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulEditorialWrap'))
      .ContentfulEditorialWrap,
)

const ContentfulCustomerStoryHero = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulCustomerStoryHero'))
      .ContentfulCustomerStoryHero,
)

const ContentfulWatchADemoCTA = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulWatchADemoCTA'))
      .ContentfulWatchADemoCTA,
)

const ContentfulTestimonialWithForm = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulTestimonialWithForm'))
      .ContentfulTestimonialWithForm,
)

const ContentfulIDLink = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulIDLink')).ContentfulIDLink,
)

const ContentfulCarousel = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulCarousel'))
      .ContentfulCarousel,
)

const ContentfulCarouselMVP = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulCarousel'))
      .ContentfulCarousel,
)

const ContentfulFeatureCarousel = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulFeatureCarousel'))
      .ContentfulFeatureCarousel,
)

const ContentfulContentDownload = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulContentDownload'))
      .ContentfulCarousel,
)

const ContentfulCSFHero = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulCSFHero'))
      .ContentfulCSFHero,
)

const ContentfulInnovationTimeline = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulInnovationTimeline'))
      .ContentfulInnovationTimeline,
)

const ContentfulSpotlightList = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulSpotlightList'))
      .ContentfulSpotlightList,
)

const ContentfulSpotlightListMvp = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulSpotlightList'))
      .ContentfulSpotlightList,
)

const ContentfulWistiaVideo = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulWistiaVideo'))
      .ContentfulWistiaVideo,
)

const ContentfulLearnLinks = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulLearnLinks'))
      .ContentfulLearnLinks,
)

const ContentfulComponentGroup = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulComponentGroup'))
      .ContentfulComponentGroup,
)

const ContentfulCardContainer = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulCardContainer'))
      .ContentfulCardContainer,
)

const ContentfulSolutionCard = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulSolutionCard'))
      .ContentfulSolutionCard,
)

const ContentfulSolutionCards = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulSolutionCards'))
      .ContentfulSolutionCards,
)

const ContentfulResourcesBanner = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulResourcesBanner'))
      .ContentfulResourcesBanner,
)

const ContentfulCTAButton = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulCTAButton'))
      .ContentfulCTAButton,
)

const ContentfulCTALink = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulCTALink')).ContentfulCTALink,
)

const ContentfulSignUpCTA = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulSignUpCTA'))
      .ContentfulSignUpCTA,
)

const ContentfulEnterpriseSolutionBanner = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulEnterpriseSolutionBanner'))
      .ContentfulEnterpriseSolutionBanner,
)

const ContentfulPricingModal = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulPricingModal'))
      .ContentfulPricingModal,
)

const ContentfulDoubleViewHero = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulDoubleViewHero'))
      .ContentfulDoubleViewHero,
)

const ContentfulWiredCards = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulWiredCards'))
      .ContentfulWiredCards,
)

const ContentfulROICalculator = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulROICalculator'))
      .ContentfulROICalculator,
)

const ContentfulLegalContent = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulLegalContent'))
      .ContentfulLegalContent,
)

const ContentfulInboundCTA = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulInboundCTA'))
      .ContentfulInboundCTA,
)

const ContentfulThankYouPageHero = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulThankYouPageHero'))
      .ContentfulThankYouPageHero,
)

const ContentfulFeatureSpotlightCarousel = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulFeatureSpotlightCarousel'))
      .ContentfulFeatureSpotLightCarousel,
)

const ContentfulAgenda = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulAgenda')).ContentfulAgenda,
)

const ContentfulEventsHero = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulEventsHero'))
      .ContentfulEventsHero,
)

const ContentfulAnchorSection = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulAnchorSection'))
      .ContentfulAnchorSection,
)

const ContentfulColumnsContainer = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulColumnsContainer'))
      .ContentfulColumnsContainer,
)

const ContentfulGridContainer = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulGridContainer'))
      .ContentfulGridContainer,
)

const ContentfulCardColumnsContainer = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulCardColumnsContainer'))
      .ContentfulCardColumnsContainer,
)

const ContentfulCrosslinkCard = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulCard'))
      .ContentfulCrosslinkCard,
)

const ContentfulStickyContent = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContenfulStickyContent'))
      .ContentfulStickyContent,
)

const ContentfulShapeSection = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulShapeSection'))
      .ContentfulShapeSection,
)

const ContentfulCustomerStoriesList = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulCustomerStoriesList'))
      .ContentfulCustomerStoriesList,
)

const ContentfulCustomerStoryCard = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulCustomerStoryCard'))
      .ContentfulCustomerStoryCard,
)

const ContentfulCompaniesMarquee = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulCompaniesMarquee'))
      .ContentfulCompaniesMarquee,
)

const ContentfulCompaniesMarqueeGroup = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulCompaniesMarqueeGroup'))
      .ContentfulCompaniesMarqueeGroup,
)

const ContentfulFooterWithCTA = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulFooterWithCTA'))
      .ContentfulFooterWithCTA,
)

const ContentfulContentSwitcher = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulContentSwitcher'))
      .ContentfulContentSwitcher,
)

const ContentfulIconGrid = dynamic(
  async () =>
    (await import('marketing-site/src/mvp-v2/transformers/components/ContentfulIconGrid'))
      .ContentfulIconGrid,
)

const ContentfulIconGridItem = dynamic(
  async () =>
    (await import('marketing-site/src/mvp-v2/transformers/elements/ContentfulIconGridItem'))
      .ContentfulIconGridItem,
)

const ContentfulTestimonialMiniCard = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulTestimonialMiniCard'))
      .ContentfulTestimonialMiniCard,
)

const ContentfulMiniTestimonialCardMVP = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/elements/ContentfulMiniTestimonialCard'))
      .ContentfulMiniTestimonialCard,
)

const ContentfulCollapsibleContent = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulCollapsibleContent'))
      .ContentfulCollapsibleContent,
)

const ContentfulCollapsibleContentMVP = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulCollapsibleContent'))
      .ContentfulCollapsibleContent,
)

const ContentfulFlowSelector = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulFlowSelector'))
      .ContentfulFlowSelector,
)

const ContentfulLostCustomer = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulLostCustomer'))
      .ContentfulLostCustomer,
)

const ContentfulCardWithModal = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulCardWithModal'))
      .ContentfulCardWithModal,
)

const ContentfulThankYouPage = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulThankYouPage'))
      .ContentfulThankYouPage,
)

const ContentfulThankYouPageSimple = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulThankYouPageSimple'))
      .ContentfulThankYouPageSimple,
)

const ContentfulMutinyCtasContainer = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulMutinyCtasContainer'))
      .ContentfulMutinyCtasContainer,
)

const ContentfulImage = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulImage')).ContentfulImage,
)

const ContentfulImageWithModalVideo = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/elements/ContentfulImageWithModalVideo'))
      .ContentfulImageWithModalVideo,
)

const ContentfulMediaByBreakpoint = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/elements/ContentfulMediaByBreakpoint'))
      .ContentfulMediaByBreakpoint,
)

const ContentfulViewDemosMultiStepForm = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulViewDemosMultiStepForm'))
      .ContentfulViewDemosMultiStepForm,
)

const ContentfulHomepageExploration = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulHomepageExploration'))
      .ContentfulHomepageExploration,
)

const ContentfulHomepageExplorationDev = dynamic(
  async () =>
    (
      await import(
        'marketing-site/src/mvp/transformers/components/ContentfulHomepageExplorationDev'
      )
    ).ContentfulHomepageExplorationDev,
)

const ContentfulFinExploration = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulFinExploration'))
      .ContentfulFinExploration,
)

const ContentfulFinloading = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulFinLoading'))
      .ContentfulFinLoading,
)

const ContentfulFinPreview = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulFinPreview'))
      .ContentfulFinPreview,
)

const ContentfulVBP3_0PricingCard = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulVBP3_0PricingCard'))
      .ContentfulVBP3_0PricingCard,
)

const ContentfulFinPageContent = dynamic(
  async () =>
    (await import('marketing-site/src/fin/transformers/components/ContentfulFinPageContent'))
      .ContentfulFinPageContent,
)

const ContentfulFinPageContentDev = dynamic(
  async () =>
    (await import('marketing-site/src/fin/transformers/components/ContentfulFinPageContentDev'))
      .ContentfulFinPageContentDev,
)

/** MVP COMPONENTS */
const ContentfulCompactTabs = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulCompactTabs'))
      .ContentfulCompactTabs,
)

const ContentfulCTAButtonMvp = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/elements/ContentfulCTAButton'))
      .ContentfulCTAButton,
)

const ContentfulCTALinkMvp = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/elements/ContentfulCTALink'))
      .ContentfulCTALink,
)

const ContentfulCrosslinkCardsMvp = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulCrosslinkCards'))
      .ContentfulCrosslinkCards,
)

const ContentfulLargeTestimonialMvp = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulLargeTestimonial'))
      .ContentfulLargeTestimonial,
)

const ContentfulJumpLinkMvp = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/elements/ContentfulJumpLink'))
      .ContentfulJumpLink,
)

const ContentfulMarketoFormMVP = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/elements/ContentfulMarketoForm'))
      .ContentfulMarketoForm,
)

const ContentfulPricingCards = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulPricingCards'))
      .ContentfulPricingCards,
)

const ContentfulPricingTable = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulPricingTable'))
      .ContentfulPricingTable,
)

const ContentfulRelatedContent = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulRelatedContent'))
      .ContentfulRelatedContent,
)

const ContentfulStickyTabs = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulStickyTabs'))
      .ContentfulStickyTabs,
)

const ContentfulTabPills = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulTabPills'))
      .ContentfulTabPills,
)

const ContentfulViewDemosPageContent = dynamic(
  async () =>
    (await import('marketing-site/src/transformers/components/ContentfulViewDemosPageContent'))
      .ContentfulViewDemosPageContent,
)

const ContentfulSubNav = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulSubNav'))
      .ContentfulSubNav,
)

const ContentfulPreFooterCTABlock = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulPreFooterCTABlock'))
      .ContentfulPreFooterCTABlock,
)

const ContentfulLogoPartyMVP = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulLogoParty'))
      .ContentfulLogoPartyMVP,
)

const ContentfulCardsWithImageMVP = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulCardsWithImage'))
      .ContentfulCardsWithImage,
)

const ContentfulVerticalTabs = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulVerticalTabs'))
      .ContentfulVerticalTabs,
)
const ContentfulFooterSecondaryLinkMarkdown = dynamic(
  async () =>
    (
      await import(
        'marketing-site/src/mvp/transformers/components/ContentfulFooterSecondaryLinkMarkdown'
      )
    ).ContentfulFooterSecondaryLinkMarkdown,
)
const ContentfulLogoCarousel = dynamic(
  async () =>
    (await import('marketing-site/src/mvp/transformers/components/ContentfulLogoCarousel'))
      .ContentfulLogoCarousel,
)
/** END MVP COMPONENTS */

/** FIN Components  */

const ContentfulCTAButtonFin = dynamic(
  async () =>
    (await import('marketing-site/src/fin/transformers/elements/ContentfulCTAButton'))
      .ContentfulCTAButton,
)

const ContentfulCTALinkFin = dynamic(
  async () =>
    (await import('marketing-site/src/fin/transformers/elements/ContentfulCTALink'))
      .ContentfulCTALink,
)

const ContentfulHeaderNavigationFin = dynamic(
  async () =>
    (await import('marketing-site/src/fin/transformers/components/ContentfulHeaderNavigation'))
      .ContentfulHeaderNavigation,
)

const ContentfulRooflineBannerFin = dynamic(
  async () =>
    (await import('marketing-site/src/fin/transformers/components/ContentfulRooflineBanner'))
      .ContentfulRooflineBanner,
)

type IComponentMap = Partial<Record<CONTENT_TYPE, ReactComponentLike>>

export const TRANSFORMED_COMPONENTS: IComponentMap = {
  addOnPricingModal: ContentfulAddonPricingModal,
  agenda: ContentfulAgenda,
  anchorSection: ContentfulAnchorSection,
  badges: ContentfulBadges,
  basicHeader: ContentfulBasicHeader,
  callout: ContentfulCallout,
  cardContainer: ContentfulCardContainer,
  cardList: ContentfulCrosslinkCards,
  cardWithIcon: ContentfulCardWithIcon,
  cardWithImage: ContentfulCardWithImage,
  interactiveCard: ContentfulInteractiveCard,
  cardWithModal: ContentfulCardWithModal,
  cardsWithIcon: ContentfulCardsWithIcon,
  cardsWithImage: ContentfulCardsWithImage,
  carousel: ContentfulCarousel,
  cardColumnsContainer: ContentfulCardColumnsContainer,
  columnsContainer: ContentfulColumnsContainer,
  companiesMarquee: ContentfulCompaniesMarquee,
  companiesMarqueeGroup: ContentfulCompaniesMarqueeGroup,
  componentGroup: ContentfulComponentGroup,
  contentDownload: ContentfulContentDownload,
  contentSwitcher: ContentfulContentSwitcher,
  crosslinkCard: ContentfulCrosslinkCard,
  csfHero: ContentfulCSFHero,
  ctaButton: ContentfulCTAButton,
  ctaLink: ContentfulCTALink,
  customerStoryGrid: ContentfulEditorialStoryGrid,
  customerStoryHero: ContentfulCustomerStoryHero,
  customerStoriesList: ContentfulCustomerStoriesList,
  customerCard: ContentfulCustomerStoryCard,
  customerWrap: ContentfulEditorialWrap,
  doubleViewHero: ContentfulDoubleViewHero,
  emailCapture: ContentfulEmailCapture,
  enterpriseSolutionBanner: ContentfulEnterpriseSolutionBanner,
  eventsHero: ContentfulEventsHero,
  collapsibleContent: ContentfulCollapsibleContent,
  featureAnnouncement: ContentfulNewFeatureAnnouncement,
  featureCarousel: ContentfulFeatureCarousel,
  featureGrid: ContentfulFeatureGrid,
  featureListSimple: ContentfulFeatureListSimple,
  featureSection: ContentfulFeatureSection,
  featureSpotlight: ContentfulFeatureSpotlight,
  featureSpotlightCarousel: ContentfulFeatureSpotlightCarousel,
  featureSpotlightVertical: ContentfulFeatureSpotlightVertical,
  featureSpotlightWithProductDemo: ContentfulFeatureSpotlightDemo,
  featureSpotlightWithTestimonial: ContentfulFeatureSpotlightTestimonial,
  featureSpotlightWithVideo: ContentfulFeatureSpotlightVideo,
  finExplorationPage: ContentfulFinExploration,
  finPageContent: ContentfulFinPageContent,
  devFinPageContent: ContentfulFinPageContentDev,
  finPreviewPage: ContentfulFinPreview,
  finDemoLoading: ContentfulFinloading,
  flowSelector: ContentfulFlowSelector,
  footer2: ContentfulFooter,
  footerWithCTA: ContentfulFooterWithCTA,
  gatedContent: ContentfulGatedContent,
  gatedContentMvp: ContentfulGatedContentMvp,
  gridContainer: ContentfulGridContainer,
  greenhouseJobListings: ContentfulGreenhouseListings,
  glossary: ContentfulGlossary,
  headerNavigation: ContentfulHeaderNavigation,
  headingBlock: ContentfulHeadingBlock,
  hero: ContentfulHero,
  heroHorizontal: ContentfulHeroHorizontal,
  heroVertical: ContentfulHeroVertical,
  heroEmailCapture: ContentfulHeroEmailCapture,
  heroForCareersPage: ContentfulHeroForCareersPage,
  heroForEarlyStage: ContentfulHeroForEarlyStage,
  heroWithCta: ContentfulHeroWithCta,
  heroWithVideo: ContentfulHeroWithVideo,
  homepageExplorationPage: ContentfulHomepageExploration,
  devHomepageExplorationPage: ContentfulHomepageExplorationDev,
  idLink: ContentfulIDLink,
  image: ContentfulImage,
  imageWithModalVideo: ContentfulImageWithModalVideo,
  inboundCta: ContentfulInboundCTA,
  innovationTimeline: ContentfulInnovationTimeline,
  contentDownloadInterstitial: ContentfulContentDownloadInterstitial,
  largeTestimonial: ContentfulLargeTestimonial,
  layout: ContentfulLayout,
  learnDirectoryLinks: ContentfulLearnLinks,
  legalContent: ContentfulLegalContent,
  logoParty: ContentfulLogoParty,
  lostCustomer: ContentfulLostCustomer,
  marketoForm: ContentfulMarketoForm,
  mediaByBreakpoint: ContentfulMediaByBreakpoint,
  miniTestimonials: ContentfulMiniTestimonials,
  mobileAppsHero: ContentfulMobileAppsHero,
  multiFeatureSpotlight: ContentfulMultiFeatureSpotlight,
  multiFeatureSpotlightMVP: ContentfulMultiFeatureSpotlightMVP,
  mutinyCtasContainer: ContentfulMutinyCtasContainer,
  planColumnGroup: ContentfulPlanColumnGroup,
  planColumnGroupLayout: ContentfulPlanColumnGroupLayout,
  platform: ContentfulPlatform,
  pricingAddOnCard: ContentfulPricingAddOnCard,
  pricingAddOns: ContentfulPricingAddOns,
  pricingModal: ContentfulPricingModal,
  pricingTierCard: ContentfulPricingTierCard,
  productList: ContentfulProductList,
  productToursDemo: ContentfulProductToursDemo,
  resourceHub: ContentfulResourceHub,
  resourcesBanner: ContentfulResourcesBanner,
  richTextEditor: ContentfulRichText,
  roiCalculator: ContentfulROICalculator,
  rooflineBanner: ContentfulRooflineBanner,
  shapeSection: ContentfulShapeSection,
  signupCta: ContentfulSignUpCTA,
  solutionCard: ContentfulSolutionCard,
  solutionCards: ContentfulSolutionCards,
  solutionFeature: ContentfulSolutionFeature,
  solutionWithTiers: ContentfulSolutionWithTiers,
  spotlightList: ContentfulSpotlightList,
  spotlightListMvp: ContentfulSpotlightListMvp,
  statistic: ContentfulStatistic,
  statistics: ContentfulStatistics,
  stickyContent: ContentfulStickyContent,
  subNav: ContentfulSubNav,
  tabbedSolutions: ContentfulTabbedSolutions,
  testimonialMiniCard: ContentfulTestimonialMiniCard,
  tabPills: ContentfulTabPills,
  testimonialTextOnly: ContentfulTestimonialTextOnly,
  testimonialWithForm: ContentfulTestimonialWithForm,
  thankYouPage: ContentfulThankYouPage,
  thankYouPageHero: ContentfulThankYouPageHero,
  thankYouPageSimple: ContentfulThankYouPageSimple,
  tierPricingSection: ContentfulTierPricingSection,
  variationContainer: ContentfulVariationContainer,
  vbp30PricingCard: ContentfulVBP3_0PricingCard,
  videoPlayer: ContentfulVideoPlayer,
  viewDemosMultiStepForm: ContentfulViewDemosMultiStepForm,
  viewDemosPageContent: ContentfulViewDemosPageContent,
  watchADemoCta: ContentfulWatchADemoCTA,
  whatsIncluded: ContentfulWhatsIncluded,
  wiredCardsComponent: ContentfulWiredCards,
  wistiaVideo: ContentfulWistiaVideo,
  /**  MVP Components */
  carouselMVP: ContentfulCarouselMVP,
  cardsWithImageMVP: ContentfulCardsWithImageMVP,
  collapsibleContentMVP: ContentfulCollapsibleContentMVP,
  compactTabs: ContentfulCompactTabs,
  crosslinkCardsMvp: ContentfulCrosslinkCardsMvp,
  ctaButtonMvp: ContentfulCTAButtonMvp,
  ctaLinkMvp: ContentfulCTALinkMvp,
  featureGridMVP: ContentfulFeatureGridMVP,
  featureSpotlightMVP: ContentfulFeatureSpotlightMVP,
  featureSpotlightVerticalMvp: ContentfulFeatureSpotlightVerticalMvp,
  featureSpotlightWithTestimonialMVP: ContentfulFeatureSpotlightWithTestimonialMVP,
  footer: ContentfulFooterMVP,
  footerSecondaryLinkMarkdown: ContentfulFooterSecondaryLinkMarkdown,
  headerNavigationMVP: ContentfulHeaderNavigationMVP,
  headingBlockMvp: ContentfulHeadingBlockMvp,
  iconGrid: ContentfulIconGrid,
  iconGridItem: ContentfulIconGridItem,
  jumpLinkMvp: ContentfulJumpLinkMvp,
  largeTestimonialMvp: ContentfulLargeTestimonialMvp,
  logoPartyMVP: ContentfulLogoPartyMVP,
  marketoFormMVP: ContentfulMarketoFormMVP,
  miniTestimonialCard: ContentfulMiniTestimonialCardMVP,
  miniTestimonialCards: ContentfulMiniTestimonialCardsMVP,
  pricingCards: ContentfulPricingCards,
  pricingTableMVP: ContentfulPricingTable,
  preFooterCTABlock: ContentfulPreFooterCTABlock,
  relatedContent: ContentfulRelatedContent,
  rooflineBannerMvp: ContentfulRooflineBannerMvp,
  spotlightCarousel: ContentfulSpotlightCarousel,
  spotlightDrawers: ContentfulSpotlightDrawers,
  stickyTabs: ContentfulStickyTabs,
  statisticMVP: ContentfulStatisticMVP,
  statisticsMVP: ContentfulStatisticsMVP,
  verticalTabs: ContentfulVerticalTabs,
  logoCarousel: ContentfulLogoCarousel,
  /** Fin Components */
  ctaButtonFin: ContentfulCTAButtonFin,
  ctaLinkFin: ContentfulCTALinkFin,
  headerNavigationFin: ContentfulHeaderNavigationFin,
  rooflineBannerFin: ContentfulRooflineBannerFin,
}

export function renderTransformedComponent(
  contentTypeId: CONTENT_TYPE,
  props: Entry<unknown> & { children?: React.ReactNode },
): React.ReactNode {
  if (contentTypeId in TRANSFORMED_COMPONENTS) {
    const Component: ReactComponentLike = TRANSFORMED_COMPONENTS[
      contentTypeId
    ] as ReactComponentLike
    return <Component {...props} />
  } else {
    throw new Error(`${contentTypeId} not implemented`)
  }
}
